import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { BottomSheetContentLayout, Menu, Popover, useDevice, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { netTermsOptions } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { TriageFieldBox } from '../TriageFieldBox/TriageFieldBox';
import { TriageRow } from '../TriageRow/TriageRow';
export const GetTriagePaymentTermsRowTID = (parentTestId)=>getTestIds(parentTestId);
export const PaymentTermsRowTestIds = GetTriagePaymentTermsRowTID().PaymentTermsRowTestIds;
const netTermsMenuItemLabel = (days, t)=>days === 0 ? t.components.netTermsDropdown.uponReceipt() : t.agreementImport.triageModal.paymentTermsMenuDays({
        count: days
    });
const PaymentTermsSheet = (param)=>{
    let { currentNetTerms, onSelect } = param;
    const { t } = useLocaleKeys();
    const { hideBottomSheet } = useOverlayContext();
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: t.agreementImport.triageModal.paymentTermsSheetTitle(),
            titleTestId: PaymentTermsRowTestIds.MobileSheetTitle(),
            gutter: 'm'
        },
        children: /*#__PURE__*/ _jsx(Menu, {
            testId: PaymentTermsRowTestIds.Menu.Root(),
            dimensions: {
                maxHeight: 320
            },
            items: netTermsOptions.map((days)=>({
                    id: String(days),
                    testId: PaymentTermsRowTestIds.Menu.Option(days),
                    title: netTermsMenuItemLabel(days, t),
                    selected: days === currentNetTerms,
                    onClick: ()=>{
                        onSelect(days);
                        hideBottomSheet();
                    }
                }))
        })
    });
};
export const TriagePaymentTermsRow = (param)=>{
    let { model, onModelChange, wrapperTestId } = param;
    const { t } = useLocaleKeys();
    const { isMobileDevice } = useDevice();
    const { pushBottomSheetPage } = useOverlayContext();
    const netTerms = model.netTerms();
    const [anchorEl, setAnchorEl] = useState(null);
    if (netTerms == null) return null;
    const displayText = model.paymentTermsDisplay(t);
    const commitNetTerms = (days)=>{
        onModelChange(model.setNetTerms(days));
    };
    const openSheet = ()=>pushBottomSheetPage({
            content: /*#__PURE__*/ _jsx(PaymentTermsSheet, {
                currentNetTerms: netTerms,
                onSelect: commitNetTerms
            })
        });
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": PaymentTermsRowTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(TriageRow, {
                label: t.agreementImport.triageModal.paymentTermsLabel(),
                wrapperTestId: wrapperTestId,
                mobile: {
                    body: displayText !== null && displayText !== void 0 ? displayText : '',
                    bodyTestId: PaymentTermsRowTestIds.MobileSummaryBody(),
                    onEdit: openSheet,
                    editTestId: PaymentTermsRowTestIds.MobileEditButton()
                },
                children: /*#__PURE__*/ _jsx(TriageFieldBox, {
                    variant: {
                        type: 'text',
                        value: displayText !== null && displayText !== void 0 ? displayText : ''
                    },
                    forceActionsVisible: anchorEl != null,
                    actions: [
                        {
                            text: t.agreementImport.triageModal.paymentTermsChangeButton(),
                            testId: PaymentTermsRowTestIds.ChangeButton(),
                            onClick: (event)=>setAnchorEl(event.currentTarget)
                        }
                    ]
                })
            }),
            !isMobileDevice && /*#__PURE__*/ _jsx(Popover, {
                anchorEl: anchorEl,
                open: anchorEl != null,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                onClose: ()=>setAnchorEl(null),
                children: /*#__PURE__*/ _jsx("div", {
                    "data-testid": PaymentTermsRowTestIds.Menu.Root(),
                    children: /*#__PURE__*/ _jsx(Menu, {
                        testId: PaymentTermsRowTestIds.Menu.Root(),
                        dimensions: {
                            maxHeight: 320,
                            width: 250
                        },
                        items: netTermsOptions.map((days)=>({
                                id: String(days),
                                testId: PaymentTermsRowTestIds.Menu.Option(days),
                                title: netTermsMenuItemLabel(days, t),
                                selected: days === netTerms,
                                onClick: ()=>{
                                    commitNetTerms(days);
                                    setAnchorEl(null);
                                }
                            }))
                    })
                })
            })
        ]
    });
};
